import { SvgPropType } from './types/svgPropType';

function BandcampIconSVG({ width, height }: SvgPropType) {
    return (
        <svg width={width || '31'} height={height || '32'} viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 0.5C6.9375 0.5 0 7.4375 0 16C0 24.5625 6.9375 31.5 15.5 31.5C24.0625 31.5 31 24.5625 31 16C31 7.4375 24.0625 0.5 15.5 0.5ZM18.5125 20.8813H7.2L12.4937 11.125H23.8062L18.5125 20.8813Z" fill="black"/>
        </svg>
    );
}

export default BandcampIconSVG;
